import React from "react";
import { useUserData } from "../../auth/useUserData.js";
import { useApolloClient } from "@apollo/client";
import { useMyOrganisationUserProfileQuery } from "../../main-routes/my-organisation/OrganisationUserProfile.generated.js";
import { Stack } from "@mui/material";
import { RestrictedByOrganisationPermissionWithDebug } from "../../auth/RestrictedByOrganisationPermission.js";
import { CardContainer } from "@msys/ui";
import {
  MyOrganisationUserAvatarAndTitleData,
  MyOrganisationUserAvatarAndTitleForm,
  MyOrganisationViewerAvatarAndTitleForm,
} from "./MyOrganisationUserAvatarAndTitleForm.js";
import { UserInformationForm } from "../users/UserInformationForm.js";
import { UserInformationBox } from "../users/UserInformationBox.js";

interface Props {
  userId: string;
}

export const MyOrganisationUserEditForm = ({ userId }: Props) => {
  const viewer = useUserData().currentUser!;
  const client = useApolloClient();
  const query = useMyOrganisationUserProfileQuery({
    client,
    variables: { userId },
    fetchPolicy: "network-only",
  });
  const user = query.data?.user;
  const isViewersUser = viewer.id === userId;

  return user ? (
    <Stack spacing={1}>
      <CardContainer>
        <Stack direction="column" p={1} spacing={1}>
          {isViewersUser ? (
            <MyOrganisationViewerAvatarAndTitleForm user={user} />
          ) : (
            <RestrictedByOrganisationPermissionWithDebug
              permission="MANAGE_ORG"
              otherwise={<MyOrganisationUserAvatarAndTitleData user={user} />}
            >
              <MyOrganisationUserAvatarAndTitleForm user={user} />
            </RestrictedByOrganisationPermissionWithDebug>
          )}

          {isViewersUser ? (
            <UserInformationForm key={`${user.id}-form`} user={user} />
          ) : (
            <RestrictedByOrganisationPermissionWithDebug
              permission="MANAGE_ORG"
              otherwise={
                <UserInformationBox key={`${user.id}-info-box`} user={user} />
              }
            >
              <UserInformationForm key={`${user.id}-info-form`} user={user} />
            </RestrictedByOrganisationPermissionWithDebug>
          )}
        </Stack>
      </CardContainer>
    </Stack>
  ) : null;
};
